import React from 'react';

import PropTypes from 'prop-types';

// This is a combination of faBox and faArrowTurnDownLeft (flipped) that Amy made
export const ReturnsIcon = ({ className }) => {
  return (
    <svg className={className} viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M405.5 264.5V189.5H52.5L53 398C53 406.8 60.16 414 69 414L224 414.5C224 414.5 246.5 416.831 246.5 438.5C246.5 460.169 224 462 224 462H69C33.65 462 5 433.3 5 398V171.6C5 162.8 6.88001 153.8 10.52 145.6L52.11 52.01C62.38 28.89 85.3 14 110.6 14H347.4C372.7 14 395.8 28.9 405.9 52.01L447.5 145.6C451.1 153.8 453 162.8 453 171.6V264.5C453 264.5 454 289 429.5 289C405 289 405.5 264.5 405.5 264.5ZM205 142V62H110.6C104.27 62 98.57 65.72 95.97 71.6L64.5 142H205ZM253 142V62H347.4C353.7 62 359.5 65.72 362 71.5L393.5 142H253Z'
        fill='currentColor'
        fillRule='evenodd'
      />
      <path
        d='M201.517 315.08L302.518 228.58C313.518 219.08 326.862 220.264 335.518 229.58C343.762 238.453 344.518 253.08 336.018 261.08L281.518 308.08H411.018C458.518 308.08 506.518 350.58 506.518 401.08V477.08C506.518 488.08 495.018 498.08 483.518 498.08C472.018 498.08 459.518 490.08 459.518 477.08V404.08C458.018 379.08 439.518 360.08 415.018 357.58L280.018 357.08L333.017 402.58C344.016 410.58 344.209 427.668 336.017 436.08C327.553 444.771 311.517 444.58 302.017 437.08L201.017 349.58C191.517 341.58 189.017 326.08 201.517 315.08Z'
        fill='currentColor'
      />
    </svg>
  );
};

ReturnsIcon.propTypes = {
  className: PropTypes.string,
};
